<template>
  <EditContactsPage
    :get-gql-query="getGqlQuery"
    :get-total-count="getTotalCount"
    :get-contacts="getContacts"
    :get-query-variables="getQueryVariables"
    :update-query-variable="updateQueryVariable"
  />
</template>

<script>
import EditContactsPage from '@/pages/Contact/EditContactsPage'
import { LIST_EDIT_GROUP_CONTACTS } from '@/backend/graphql/groupGQL'
export default {
  name: 'EditGroupContactsPage',
  components: {
    EditContactsPage
  },
  data: function () {
    return {
      getGqlQuery: LIST_EDIT_GROUP_CONTACTS,
      limit: 50,
      offset: 0,
      orderBy: '-profile__id,-profile__last_recv_at',
      groupId: 0,
      profileIsDelete: 0
    }
  },
  created () {
    this.groupId = this.$route.params.groupId
  },
  methods: {
    getTotalCount (data) {
      return data.listGroupProfile.totalCount
    },
    getContacts (data) {
      return data.listGroupProfile.results.map(obj => obj.profile)
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        groupId: this.groupId,
        profileIsDelete: this.profileIsDelete
      }
    },
    updateQueryVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    }
  }
}
</script>

<style scoped>

</style>
